import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicDetails: {
    code: '',
    name: '',
    description: '',
    status: 'ACTIVE',
    serviceIds: []
  }
};

export const BenefitAggregateSlice = createSlice({
  name: 'benefitAggregate',
  initialState,
  reducers: {
    setBasicDetails: (state, action) => {
      state.basicDetails = action.payload;
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.basicDetails[field] = value;
    },
    setServices: (state, action) => {
      state.basicDetails.serviceIds = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setBasicDetails,
  setField,
  setServices,
  reset,
} = BenefitAggregateSlice.actions;

export default BenefitAggregateSlice.reducer;
